import { ValueOfKey } from '../../../../utils-types';

export const PAYMENT_METHODS = {
  NEW_CARD: 'NEW_CARD',
  RETRY_WITH_CURRENT_CARD: 'RETRY_WITH_CURRENT_CARD',
} as const;

export type PaymentMethodType = ValueOfKey<typeof PAYMENT_METHODS>;
